import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import PayInvoicesForm from "@components/dynamic/PayInvoicesForm";

type PayInvoicesIndexProps = {
  manualRecibe?: boolean
}

const PayInvoicesIndex = (props: PayInvoicesIndexProps) => {
  const { manualRecibe = false } = props
  useEffect(() => {
  }, []);


  return (
    <PageContainer
      title={`Cancelar Facturas ${manualRecibe ? "Manualmente" : ""} `}
      backUrl="/user/dashboard-accounting"
    >
      <PayInvoicesForm manualRecibe={manualRecibe} />
    </PageContainer >
  );
}

export default PayInvoicesIndex;
